import React, { type SVGProps } from "react";

export default function SupPoint(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="320" height="320" viewBox="0 0 320 320" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="8" y="8" width="304" height="304" rx="152" fill="#C3BBEC" />
      <rect x="8" y="8" width="304" height="304" rx="152" stroke="#312B46" strokeWidth="16" />
      <rect x="37" y="37" width="246" height="246" rx="123" fill="#312B46" />
      <path
        d="M112.964 105.46C131.32 105.46 142.815 110.435 157.054 122.444L144.53 137.54C131.835 126.904 124.458 123.988 112.621 123.988C99.9257 123.988 92.0342 129.992 92.0342 137.712C92.0342 146.29 100.612 148.52 119.655 152.809C146.074 158.813 158.255 165.847 158.255 184.89C158.255 205.82 141.957 220.745 115.023 220.745C95.4653 220.745 82.7702 215.084 66.1293 200.33L78.996 185.233C94.436 198.1 102.671 202.045 115.366 202.045C128.061 202.045 137.153 196.556 137.153 186.605C137.153 176.14 126.517 174.596 109.533 170.822C79.8537 163.96 71.1044 155.382 71.1044 138.398C71.1044 119.699 87.9169 105.46 112.964 105.46Z"
        fill="#C3BBEC"
      />
      <path
        d="M215.325 107.861C236.598 107.861 250.151 121.757 250.151 142.516C250.151 163.445 236.598 176.998 215.325 176.998H191.651V218H170.721V107.861H215.325ZM211.551 159.328C222.359 159.328 229.221 153.324 229.221 142.516C229.221 131.536 222.359 125.532 211.551 125.532H191.651V159.328H211.551Z"
        fill="#C3BBEC"
      />
    </svg>
  );
}
